<template lang="pug">
.report-root
    general-title(
        title="客户端信息",
        description="帮助您了解访客访问您网站使用的客户端信息，在网站设计和优化时可以作为参考",
        pos="right",
        :date="timeSpan"
    )

    ul.tab
        li.tab-item(v-for="tab in dtTypes", :key="tab[1]")
            a.tabview-btn(
                :class="{active: dtType === tab}",
                @click="dtType = tab"
            ) {{tab[1]}}
    timeSpan(@change="onTimespanChange")

    .zone
        TableTitle(icon="fa fa-signal", title="客户端信息分布图")
        hr.header-chart-line
        RadioSquare(
            :items="fluxDimensions",
            v-model="curDimension",
            style="margin-left: 30px; font-size: 12px;"
        )
        BarChart(
            :xAxis="fluxTrendXAxis",
            :valueAxis= "valueAxis",
            :series="fluxTrendSeries",
            :tooltip="fluxTooltip"
            dir="vertical",
            :color="barColors",
            :loading="fluxLoading"
        )

    .zone
        TableTitle(icon="fa fa-list", :title="dtType[1] + '报表'")
            div.download-btn(v-show="fluxOriginList.length")
                DownloadBtn(
                    reportApi="/api/report/client",
                    :pagetitle="dtType[1] + '报表'",
                    :params="downloadParams"
                )
            CustomIndice(:defaults="defaultCustomIndices", @change="onCustomIndiceChange")
        ComplexTable(v-bind:columns="columns" v-bind:list="fluxOriginList", :sum = "{}")
        v-pagination(
         :total="total",
         :pn="pg",
         :ps="ps",
         v-if="total > ps",
         @updatepage="updatePage")
</template>

<script>
/* global _ */
import ComplexTable from '../../component/complex-table.vue'
import {getDateString} from '../../script/util'
import Tool from '../../script/tool.js'

import { INDICE_MAP } from './constants'
import Mixin from '../mixin.js'

const indices = [
  ['', '请选择指标'],
  ['pv', '浏览量(PV)'],
  ['uv', '访客数(UV)'],
  ['ipnum', 'IP'],
  ['newvst', '新独立访客'],
  ['tnum', '自定义转化次数'],
  ['atime', '平均访问时长']
]
const dtTypes = [
  [1, '浏览器'],
  [7, '运营商'],
  [2, '操作系统'],
  [4, '分辨率'],
  [8, '终端类型']
]

export default {
  components: {
    ComplexTable
  },
  mixins: [Mixin],
  data () {
    const today = getDateString(new Date())
    const fluxDimensions = indices.slice(1).map(item => ({
      label: item[1],
      value: item[0]
    }))
    const fluxTrendXAxis = dtTypes.reduce((result, item) => {
      result.push(item[1])
      return result
    }, [])

    return {
      fluxTrendXAxis: fluxTrendXAxis,
      timeSpan: {
        start: today,
        end: today
      },

      barColors: ['#56BF8B', '#73ACE6', '#BF86B6'],

      dtTypes,
      dtType: dtTypes[0],

      fluxDimensions,
      curDimension: fluxDimensions[0],
      fluxTrendBase: [],

      fluxLoading: true,

      fluxListOrder: ['', 0],
      isListLoading: true,
      defaultCustomIndices: ['pv', 'uv', 'ipnum', 'newvst', 'atime', 'tnum'],
      tableIndices: ['pv', 'uv', 'ipnum', 'newvst', 'atime', 'tnum'],
      pg: 1,
      ps: 10,
      total: 0
    }
  },

  computed: {
    columns () {
      let columns = [
        {
          title: '分析维度',
          fixed: true,
          children: [
            {
              title: this.dtType[1],
              width: 300,
              key: 'datum'
            }
          ]
        }
      ]
      const customColumns = [
        {
          title: '基础流量指标',
          children: [
            {
              title: '浏览量(PV)',
              key: 'pv',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '访客数(UV)',
              key: 'uv',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: 'IP',
              key: 'ipnum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '新独立访客',
              key: 'newvst',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '访问次数',
              key: 'vnum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            }
          ]
        },
        {
          title: '流量质量指标',
          children: [
            {
              title: '平均访问时长',
              key: 'atime',
              class: 'right',
              sorter: this.sorter,
              render: this.atimeRender
            },
            {
              title: '平均访问页数',
              key: 'anum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '跳出率',
              class: 'right',
              key: 'jrate',
              sorter: this.sorter,
              render: this.percentRender
            }
          ]
        },
        {
          title: '自定义转化指标',
          children: [
            {
              title: '自定义转化次数',
              key: 'tnum',
              class: 'right',
              sorter: this.sorter,
              render: this.columnRender
            },
            {
              title: '转化率',
              key: 'trate',
              class: 'right',
              sorter: this.sorter,
              render: this.percentRender
            }
          ]
        }
      ]

      const newColumns = _.filter(customColumns, (item) => {
        const newItem = _.filter(item.children, (child) => {
          if (this.tableIndices.includes(child.key)) {
            return child
          }
        })
        item.children = newItem
        if (item.children.length > 0) {
          return item
        }
      })
      columns = _.concat(columns, newColumns)

      return columns
    },

    domainId () {
      return this.$store.state.domainId
    },
    params () {
      const { start, end } = this.timeSpan
      return {
        domainId: this.domainId,
        start,
        end,
        ps: this.ps,
        pg: this.pg,
        cycle: start === end ? 'hour' : 'day',
        dttype: this.dtType[0] || 1,
        groupby: 'datum',
        no_sp_pp: 1,
        isasc: 0,
        order: 'pv'
      }
    },
    fluxTooltip () {
      const { label } = this.curDimension
      if (label !== '平均访问时长') {
        return `{b}<br>${label}：{c}`
      } else {
        return (params) => {
          const { name, value, seriesName } = params
          return `${name}</br>${seriesName}：${Tool.timeFormate(value)}`
        }
      }
    },
    valueAxis () {
      if (this.curDimension.value === 'atime') {
        return [
          {
            type: 'value',
            axisLabel: {
              formatter (value, index) {
                return `${Math.ceil(value / 60)}分钟`
              }
            }
          }
        ]
      } else {
        return []
      }
    },
    fluxTrendSeries () {
      const { value, label } = this.curDimension
      // 需要对浏览器名称进行一次转换
      return this.fluxTrendBase.map(item => ({
        name: item.datum,
        legend: label,
        value: item[value]
      })).slice(0, 10)
    },

    downloadParams () {
      return _.extend({}, this.params)
    },
    tableIndicesMapped () {
      return this.tableIndices.map(key => {
        return {
          field: key,
          name: INDICE_MAP[key]
        }
      })
    },
    fluxOriginList () {
      const list = _.cloneDeep(this.fluxTrendBase)
      const [name = 'pv', isAsc] = this.fluxListOrder
      return list.sort((a, b) => {
        const diff = a[name] - b[name]
        return isAsc ? diff : -diff
      }).slice(0, 10)
    }
  },
  watch: {
    params (newVal) {
      this.getFluxData(newVal)
    }
  },
  methods: {
    onTimespanChange ({ start, end }) {
      this.timeSpan = { start, end }
    },
    onCustomIndiceChange (indices) {
      this.tableIndices = indices
    },
    sorter (key, order) {
      this.fluxListOrder = [key, order]
    },
    getFluxData (param = {}) {
      if (!this.domainId) return Promise.resolve([])

      this.isListLoading = true
      this.fluxLoading = true
      return this.$http.get('/api/report/client', {
        params: _.extend({}, param)
      }).then((r) => {
        this.total = r.data.total
        return (r.data.list || [])
      }).catch(() => {
        return []
      }).then(list => {
        this.isListLoading = false
        this.fluxLoading = false
        this.fluxTrendBase = list
      })
    },
    updatePage (pg) {
      this.pg = pg
      this.getFluxData(this.params)
    }
  },
  created () {
    this.getFluxData(this.params)
  }
}
</script>

<style scoped>
.zone {
    background: #fff; 
    margin-bottom: 20px;
}

.data-table {
    table-layout: fixed;
}
.charts {
  border: 0;
}
</style>




// WEBPACK FOOTER //
// client.vue?fbe23e1c